module.exports = __webpack_public_path__ + "img/img-128.680a9ae1.png";